<template>
  <div class="fourCards">
    <div class="container-flued">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h4>WHAT SETS US APART FROM THE OTHER INDUSTRY LEADERS</h4>
          </div>
          <div class="col-lg-4">
            <div class="zCard" @click="goto('LifeInsurance')">
              <img src="@/assets/au1.png" />
              <h5>Transparency</h5>
              <p>
                We present potential clients with a vast amount of information
                to enable them to choose the best lead generating agency for
                their needs. We exclusively concentrate on producing
                high-quality leads.
              </p>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="zCard">
              <img src="@/assets/au2.png" />
              <h5>Best Team</h5>
              <p>
                We have access to the world's top Lead Generation experts.
                Everybody works hard to get better and adjust to the needs of
                the client.
              </p>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="zCard">
              <img src="@/assets/au3.png" />
              <h5>Building Bond</h5>
              <p>
                We are aware of the value of interpersonal connection in this
                technologically advanced society. We cherish and work hard to
                sustain enduring, mutually beneficial connections with each and
                every one of our client.
              </p>
            </div>
          </div>
        </div>
        <!--/row-->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AboutCards',
  props: {
    msg: String,
  },
  methods: {
    goto(selectedName) {
      this.$router.push({ name: selectedName, replace: true });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.fourCards {
  background: rgba(242, 242, 242, 0.6);
  padding-bottom: 40px;
  h4 {
    color: #292341;
    font-family: Inter;
    font-size: 48px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-align: center;
    margin-top: 40px;
    margin-bottom: 20px;
  }
  h5 {
    color: #ffc93c;
    font-family: Inter;
    font-size: 32px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    text-align: center;
    margin-bottom: 30px;
  }
  .zCard {
    margin: 20px;
    border-radius: 8px;
    border: 1px solid rgba(0, 52, 120, 0.26);
    background: #292341;
    text-align: center;
    padding-top: 40px;
    padding-bottom: 30px;
    padding-left: 20px;
    padding-right: 20px;
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    box-sizing: border-box;
    cursor: pointer;
    min-height: 320px;
    img {
      display: inline-block;
      height: 60px;
    }
    h5 {
      color: #fff;
      font-family: Inter;
      font-size: 20px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      margin-top: 20px;
    }
    p {
      color: #fff;
      font-family: Inter;
      font-size: 18px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      margin-top: 10px;
      text-align: justify;
      min-height: 160px;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    a {
      border-radius: 8px;
      border: 2px solid #ffc93c;
      color: #fff;
      font-family: Inter;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      padding: 4px 12px;
      text-decoration: none;
    }
  }
}
@media screen and (max-width: 1300px) {
  .fourCards {
    .zCard {
      p {
        font-size: 14px;
      }
    }
  }
}
@media screen and (max-width: 992px) {
  .fourCards {
    h4 {
      font-size: 32px;
    }
  }
}
</style>
